module.exports = __webpack_public_path__ + "fonts/opensans-bold.58308bcc.woff";